import { FC } from 'react'

export const TechnicalAccessDenied: FC<{ title?: string; message?: string }> = ({
  title = 'Access denied',
  message = 'You do not have permission to view this page.',
}) => (
  <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
    <div className='alert alert-warning m-10'>
      <h4 className='mb-2'>{title}</h4>
      <p className='mb-0'>{message}</p>
    </div>
  </div>
)
